
(() => {
  const q=(s,r=document)=>r.querySelector(s), qa=(s,r=document)=>[...r.querySelectorAll(s)];

  function getProductForm(){
    return q('product-form form') || q('form[action*="/cart/add"]');
  }

  function syncSticky(){
    const bar=q('#MargaloMobileStickyATC');
    if(!bar) return;
    bar.hidden = window.innerWidth > 749;
    const form=getProductForm();
    if(!form) return;
    const price=q('[data-product-price], .price, .price__regular');
    const target=q('.margalo-mobile-sticky-atc__price',bar);
    if(price && target) target.textContent = price.textContent.trim().replace(/\s+/g,' ');
  }

  function clickSticky(){
    const form=getProductForm();
    if(!form) return;
    const nativeBtn=q('[type="submit"][name="add"], button[type="submit"]',form);
    if(nativeBtn) nativeBtn.click();
  }

  function normalize(v){return (v||'').toLowerCase().replace(/[\s_\/]+/g,'-').replace(/[^a-z0-9äöüß-]/g,'');}

  // Hide media belonging to non-selected color where media alt/title includes a color token.
  function filterVariantMedia(){
    const checked = q('input[type="radio"]:checked');
    const select = q('select[name*="option"]');
    const selected = normalize(checked?.value || select?.value || '');
    if(!selected) return;

    const known = [
      ['silver-white',['silver-white','silverwhite','silber-white','silber-weiß','silber-weiss']],
      ['silver-black',['silver-black','silverblack','silber-black','silber-schwarz']],
      ['black-black',['black-black','blackblack','schwarz-schwarz']]
    ];
    let family=null;
    for(const [key,vals] of known){
      if(vals.some(v=>selected.includes(normalize(v)))) { family=key; break; }
    }
    if(!family) return;

    const nodes=qa('[data-media-id], .product-media-container, .product__media-item, [data-product-media]');
    nodes.forEach(el=>{
      const img=q('img',el);
      const hay=normalize([img?.alt, el.getAttribute('aria-label'), el.dataset?.alt].filter(Boolean).join(' '));
      const mentionsAny = known.some(([,vals])=>vals.some(v=>hay.includes(normalize(v))));
      const matches = known.find(([key,vals])=>key===family)?.[1].some(v=>hay.includes(normalize(v)));
      if(mentionsAny) el.style.display = matches ? '' : 'none';
    });
  }

  function enhanceDiscountLines(){
    // Only reflect REAL Shopify discounts returned in cart data/markup.
    qa('.cart-item, .cart-drawer__item, [data-cart-item]').forEach(item=>{
      const text=item.textContent || '';
      const discountText=q('.discounts, .cart-discount, [class*="discount"]', item);
      if(!discountText) return;
      if(/100%|free|gratis|buy\s*2|get\s*1/i.test(discountText.textContent)){
        const price=q('.price, [class*="price"]',item);
        if(price && !price.classList.contains('margalo-free-price')){
          price.classList.add('margalo-free-price');
          const original=price.textContent.trim();
          price.innerHTML=`<del>${original}</del><strong> GRATIS</strong>`;
        }
        if(!q('.margalo-bogo-badge',item)){
          const badge=document.createElement('span');
          badge.className='margalo-bogo-badge';
          badge.textContent='Buy 2 Get 1 · Free item';
          item.appendChild(badge);
        }
      }
    });
  }

  function init(){
    syncSticky();
    filterVariantMedia();
    enhanceDiscountLines();

    q('[data-margalo-sticky-atc]')?.addEventListener('click',clickSticky);

    document.addEventListener('change', e=>{
      if(e.target.matches('input[type="radio"], select[name*="option"]')){
        setTimeout(()=>{filterVariantMedia();syncSticky()},80);
      }
    });

    const refreshCartDecorations=()=>setTimeout(enhanceDiscountLines,100);
    document.addEventListener('cart:update',refreshCartDecorations);
    document.addEventListener('cart:updated',refreshCartDecorations);
    document.addEventListener('cart:refresh',refreshCartDecorations);
    window.addEventListener('resize',syncSticky,{passive:true});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
